import React from "react";
import { Button } from "@mui/material";

function Forbidden() {
  return (
    <div className="text-center">
      <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6">
        No Permission
      </h1>
      <Button
        href="/"
        className="px-4 py-2 text-sm md:text-base bg-brand-blue-500 text-white rounded hover:bg-brand-blue-600"
      >
        Go Home
      </Button>
    </div>
  );
}

export default Forbidden;
